// extracted by mini-css-extract-plugin
export var quote = "styles-module--quote--GYqoe";